// import React, { useRef, useState, useEffect } from "react";
import React from "react";
import { styled } from "@mui/system";
import { Grid, Box } from "@mui/material";
import Footer from "../components/Shared/Footer";
import Navbar from "../components/NavBar/Navbar";
import HeroLeft from "../components/Home_Page/HeroLeft";
// import useGetSiteImage from  "../hooks/useGetSiteImage";
// import { zoom } from "@mui/material";

const GridContainerMain = styled(Grid)({
  paddingLeft: "0px",
  paddingRight: "0px",
  paddingTop: "0px",
  minHeight: "100vh",
  "@media (max-width: 1400px)": {
      minHeight: "80vh",
  },
});

function Home() {
  return (
    <div style={{background: "linear-gradient(to bottom, rgba(209, 207, 207, 0.9), rgba(255, 255, 255, 0.9))"}}>
        <Box
      sx={{
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          zIndex: -1,
          bottom: 0,
          left: 0,
          right: 0,
          top: {
            xs: '20vh',
            sm: '230% 80%',
            md: '150% 80%',
            lg: 'cover',
          },

          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/background.png)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom center",
          // backgroundSize: "cover", // <- keeps ratio
          backgroundSize: {
            xs: ' 120vh',
            sm: 'cover',
            md: 'cover',
            lg: 'cover',
          },

          // This controls "how tall" the background region is
          // so the crop stays similar across screens:
          height: { xs: "70vh", sm: "90vh", md: "110vh", lg: "120vh" },

          // Optional: prevent the image from getting too huge on ultrawide
          maxHeight: "1200px",
        },
      }}
    >


      <Navbar />
      <GridContainerMain
        container
        sx={{
          paddingBottom: {
            xs: "0px",
            sm: "150px",
            md: "100px",
            lg: "100px",
            xl: "300px",
          },
        }}
      >
        {/* HeroLeft */}
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{zIndex: 1}}>
          <HeroLeft />
        </Grid>

      </GridContainerMain>
      <Footer />
    </Box>
    </div>
  );
}

export default Home;